import {
    FETCH_DEVICES_PENDING,
    FETCH_DEVICES_FULFILLED,
    FETCH_DEVICES_REJECTED,
    FETCH_DEVICE_PENDING,
    FETCH_DEVICE_FULFILLED,
    FETCH_DEVICE_REJECTED,
    FILTER_DEVICES_FULFILLED,
    SEARCH_DEVICES_FULFILLED,
    SORT_DEVICES_FULFILLED,
    SORT_DEVICES_PENDING,
    UPDATE_DEVICE_FULFILLED,
    UPDATE_DEVICE_PENDING,
    ADD_DEVICE_FULFILLED,
    ADD_DEVICE_REJECTED,
    ADD_DEVICE_PENDING
} from '../Actions/DeviceActions';

import { FilterType } from '../../DeviceBrowser/FilterType';
import { SortType } from '../../DeviceBrowser/SortType';
import { DirectionType } from '../../DeviceBrowser/DirectionType';


// Initialise State
const initialState = {
    devices: [],
    device: {},
    filteredDevices: [],
    fetchingDevice: false,
    fetchedDevice: false,
    failedDevice: false,
    updating: false,
    activeFilter: FilterType.ASSOCIATED,
    activeSort: SortType.ALPHABETICALLY,
    activeDirection: DirectionType.ASCENDING,
};

// Reducer
export const DevicesReducer = (state = initialState, action) => {
    
    let newState = Object.assign({}, state);

    function sort(devices, sortType, directionType) {
       return devices.sort(function(a, b){
            if (sortType === SortType.ALPHABETICALLY) {
                var nameA = a.LatestSetupPharmacyId, nameB = b.LatestSetupPharmacyId;
                if (nameA < nameB) //sort string ascending
                    return directionType === DirectionType.ASCENDING ? -1 : 1;
                if (nameA > nameB)
                    return directionType === DirectionType.ASCENDING ? 1 : -1;
                return 0;
            } else if (sortType === SortType.BATTERY_PERCENT) {
                var battery1 = 0, battery2 = 0;

                if(a.hasOwnProperty("DeviceDetails")) {
                    if (a.DeviceDetails.hasOwnProperty("dynamicDevice")) {
                        if (a.DeviceDetails.dynamicDevice.batteryLevel) {
                            battery1 = a.DeviceDetails.dynamicDevice.batteryLevel;
                        }
                    }
                }

                if(b.hasOwnProperty("DeviceDetails")) {
                    if (b.DeviceDetails.hasOwnProperty("dynamicDevice")) {
                        if (b.DeviceDetails.dynamicDevice.batteryLevel) {
                            battery2 = b.DeviceDetails.dynamicDevice.batteryLevel;
                        }
                    }
                }

                if (battery1 < battery2) //sort string ascending
                    return directionType === DirectionType.ASCENDING ? -1 : 1;
                if (battery1 > battery2)
                    return directionType === DirectionType.ASCENDING ? 1 : -1;
                return 0;
            }
        });
    }


    function filter(devices, filterType) {
        return devices.filter(device => {
            switch(filterType) {
                case FilterType.ALL: 
                    return true;
            }
        });
    }


    function search(devices, searchText) {
         return devices.filter(device => {
            return (device.deviceName.toLowerCase()).includes(searchText);
        })
    }


    switch(action.type) {
        case ADD_DEVICE_PENDING: 
            return {
                ...state,
                fetchingDevice: true,
                fetchedDevice: false,
                failedDevice: false
            };
        case ADD_DEVICE_REJECTED: 
            return {
                ...state,
                fetchingDevice: false,
                fetchedDevice: false,
                failedDevice: true
            };
        case ADD_DEVICE_FULFILLED: 
            newState.devices.push(action.payload);

            return {
                ...state,
                devices: newState.devices,
                fetchingDevice: false,
                fetchedDevice: true,
                failedDevice: false
            };
        case FETCH_DEVICES_PENDING:
            return {
                ...state,
                devices: [],
                filteredDevices: [],
                fetchingDevice: true,
                fetchedDevice: false,
                failedDevice: false
            };
        case FETCH_DEVICES_FULFILLED:
            return {
                ...state,
                devices: action.payload,
                filteredDevices: action.payload,
                fetchingDevice: false,
                fetchedDevice: true,
                failedDevice: false
            };
        case FETCH_DEVICES_REJECTED:
            return {
                ...state,
                devices: [],
                filteredDevices: [],
                fetchingDevice: false,
                fetchedDevice: false,
                failedDevice: true
            };
        case FETCH_DEVICES_REJECTED:
            return {
                ...state,
                fetchingDevice: false,
                fetchedDevice: false,
                failedDevice: true,
            };
        case FETCH_DEVICE_PENDING:
            return {
                ...state,
                fetchingDevice: true,
                fetchedDevice: false,
                failedDevice: false
            };
        case FETCH_DEVICE_FULFILLED:
            return {
                ...state,
                device: action.payload,
                fetchingDevice: false,
                fetchedDevice: true,
                failedDevice: false
            };
            
        case UPDATE_DEVICE_PENDING:
            return {
                ...state,
                updating: true,
            };
        case UPDATE_DEVICE_FULFILLED:
            return {
                ...state,
                updating: false,
            };
        case FETCH_DEVICE_REJECTED:
            return {
                ...state,
                device: [],
                fetchingDevice: false,
                fetchedDevice: false,
                failedDevice: true
            };
        case SEARCH_DEVICES_FULFILLED:
            return {
                ...state,
                filteredDevices: search(newState.devices, action.payload.toLowerCase()),
                fetchingDevice: false,
                fetchedDevice: true,
                failedDevice: false
            };
        case SORT_DEVICES_PENDING:
            return {
                ...state,
                fetchingDevice: true,
                fetchedDevice: false,
                failedDevice: false
            };
        case SORT_DEVICES_FULFILLED:
            return {
                ...state,
                filteredDevices: sort(newState.devices, action.payload.sortType, action.payload.directionType),
                activeDirection: action.payload.directionType,
                activeSort: action.payload.sortType,
                fetchingDevice: false,
                fetchedDevice: true,
                failedDevice: false
            };

        case FILTER_DEVICES_FULFILLED:
            return {
                ...state,
                filteredDevices: filter(newState.devices, action.payload),
                fetchingDevice: false,
                fetchedDevice: true,
                failedDevice: false,
                activeFilter: action.payload
            };
        default:
            return state;
    }
};